<template>
    <el-select :value="valorAtual" @change="$emit('save', $event)" style="max-width: 400px;">
        <el-option v-for="op in opcoes" :key="op.v" :label="op.l" :value="op.v"></el-option>
    </el-select>
</template>

<script>
// Editor de opção fixa para os parâmetros de avaliação por conceito
// (avaliacao.metodo e avaliacao.conceito_modo), diario.frequencia_modo e diario.nota_modo. Emite 'save' com o valor selecionado.
import { CHAVE_AVALIACAO_CONCEITO_MODO, CHAVE_AVALIACAO_CONCEITO_GRANULARIDADE, CHAVE_DIARIO_FREQUENCIA_MODO, CHAVE_DIARIO_NOTA_MODO, METODO_AVALIACAO, CONCEITO_MODO, CONCEITO_GRANULARIDADE, FREQUENCIA_MODO, NOTA_MODO } from '@/shared/constants/avaliacaoConceito'

export default {
    name: 'AvaliacaoSelectEditor',
    props: {
        p: { type: Object, required: true },
        valor: { default: null }
    },
    computed: {
        opcoes () {
            if (this.p.chave === CHAVE_AVALIACAO_CONCEITO_MODO) return CONCEITO_MODO
            if (this.p.chave === CHAVE_AVALIACAO_CONCEITO_GRANULARIDADE) return CONCEITO_GRANULARIDADE
            if (this.p.chave === CHAVE_DIARIO_FREQUENCIA_MODO) return FREQUENCIA_MODO
            if (this.p.chave === CHAVE_DIARIO_NOTA_MODO) return NOTA_MODO
            return METODO_AVALIACAO
        },
        valorAtual () {
            return (this.valor === null || this.valor === undefined || this.valor === '')
                ? this.opcoes[0].v
                : String(this.valor)
        }
    }
}
</script>
